// extracted by mini-css-extract-plugin
module.exports = {"matchedPaths":"MatchedPaths_matchedPaths__2nlVf","tableResponsive":"MatchedPaths_tableResponsive__1P5LD"};